import React from 'react';
import { OrdenesTrabajoProvider } from '@/contexts/OrdenesTrabajoContext';
import Clientes from './Clientes';

const ClientesWrapper = () => {
  return (
    <OrdenesTrabajoProvider>
      <Clientes />
    </OrdenesTrabajoProvider>
  );
};

export default ClientesWrapper;